import { FC } from 'react'

import styles from './Widget.module.scss'

export const Widget: FC<{ label: string; value: string }> = ({ label, value }) => {
  return (
    <div className={styles.widget}>
      <div className={styles.label}>{label}</div>
      <div className={styles.value}>{value}</div>
    </div>
  )
}
